import ReactRenderer from 'helpers/ReactRenderer';
import UserSignUp from 'components/users/devise/sign-up/index';
import UserSignIn from 'components/users/devise/sign-in/index';
import ForgotPassword from 'components/users/devise/forgot-password/index';
import ChangePassword from 'components/users/devise/change-password';
import ResetConfirmation from 'components/users/devise/confirmation/index';
import AdminSignIn from 'components/admin/devise/index';
import FlashMessages from 'components/FlashMessages';
import UsersTwoFactorAuthenticationsNew from 'components/users/two-factor-authentications';
import CookieBanner from 'components/CookieBanner';

(new ReactRenderer).setup({
  UserSignUp,
  UserSignIn,
  ForgotPassword,
  ChangePassword,
  ResetConfirmation,
  AdminSignIn,
  FlashMessages,
  UsersTwoFactorAuthenticationsNew,
  CookieBanner
});
